/**
 * Which tome vibe each zone wears (lane N; shared by plan 17). Config, not
 * code: NPC windows take the vibe of the zone that spawns their NPC
 * (Systems/NPC/npcTomeVibe.ts), and the HUD takes the vibe of the zone the
 * player is in (HUD/useHudTomeVibe.ts). Vibes themselves live in tomeVibes.ts.
 */
import type { TomeVibeName } from './tomeVibes';

/** Zone → vibe. Zones not listed wear the default tome. */
export const ZONE_TOME_VIBES: Partial<Record<string, TomeVibeName>> = {
  first_field: 'grove',
  lanternwood: 'grove',
  dark_forest: 'grove',
  moonfall_hollow: 'moonfall',
  moonfen_pasture: 'moonfall',
  tidewend: 'harbour',
  tidewend_outskirts: 'harbour',
  pig_beach: 'harbour',
};

/** The vibe a zone wears; unknown or missing zones wear `default`. */
export function zoneTomeVibe(zoneId: string | null | undefined): TomeVibeName {
  return (zoneId && Object.prototype.hasOwnProperty.call(ZONE_TOME_VIBES, zoneId) && ZONE_TOME_VIBES[zoneId]) || 'default';
}
